<template>
  <div class="Warp">
    <van-grid :column-num="4" :border="false">
      <van-grid-item text="卡券名称" />
      <van-grid-item text="卡券类型" />
      <van-grid-item text="卡券数量" />
      <van-grid-item text="失效日期" />
    </van-grid>
    <van-pull-refresh v-model="refreshLoading" @refresh="onRefresh">
      <van-list
        v-model="loading"
        :finished="finished"
        finished-text="没有更多了"
        @load="uploader"
      >
        <div
          v-for="item in couponList"
          :key="item.company_id"
          @click="toDetail(item)"
        >
          <van-grid :column-num="4" :border="false">
            <van-grid-item :text="item.title"> </van-grid-item>
            <van-grid-item
              :text="item.card_type == 'FULL_REDUCE' ? '满减' : '折扣'"
            />
            <!-- <van-grid-item class="compant_name" text="说的话就发了客户接受的了看见对方离开手机都发了看见了可上单就放开了" /> -->
            <van-grid-item :text="item.num + ''" />
            <van-grid-item>
              <div class="van_grid_item">{{ item.date }}</div>
              <div class="van_grid_item">{{ item.time }}</div>
            </van-grid-item>
          </van-grid>
        </div>
      </van-list>
    </van-pull-refresh>
  </div>
</template>
<script>
export default {
  data() {
    return {
      page: 1,
      limit: 10,
      couponList: [],
      loading: false,
      refreshLoading: false,
      finished: false,
    };
  },
  mounted() {
    this.getCouponList();
  },
  methods: {
    getCouponList() {
      var reqData = {
        page: this.page,
        limit: this.limit,
      };
      this.$http
        .get("/wechat/api.coupon/getCoupon", { params: reqData })
        .then((res1) => {
          var res = res1.body;
          res.data.rows.map((v) => {
            let data_time = v.limit_end_date.split(" ");
            v.date = data_time[0];
            v.time = data_time[1];
            this.couponList.push(v);
            console.log(data_time);
            this.loading = false;
            this.refreshLoading = false;
            if (this.couponList.length >= res.data.count) {
              this.finished = true;
            }
          });
        });
    },
    onRefresh() {
      this.page = 1;
      this.couponList = [];
      this.finished = false;
      this.getCouponList();
    },
    uploader() {
      this.page++;
      this.getCouponList();
    },
    toDetail(item) {
      this.$router.push({
        path: "/statement_detail",
        query: item,
      });
    },
  },
};
</script>
<style lang="less" scoped>
.van_grid_item {
  color: #646566;
  font-size: 0.32rem;
  line-height: 1.5;
  word-break: break-all;
}
</style>